<template>
    <el-dialog title="Changer les titres" v-loading="loader" :visible.sync="display" width="50%">
        <div class="mb-3">Modifier les {{ items_selected }} produits selectionnés</div>
        <el-form class="formTitle" ref="form" :model="form">
            <div class="row">
                <el-form-item prop="comment" class="col-lg-5" label="Commentaire">
                    <el-input placeholder="Commentaire" type="textarea" :rows="4" v-model="form.comment"></el-input>
                </el-form-item>
                <el-form-item prop="remove_comment" class="col-lg-5" label="Supprimé les commentaires ?">
                    <el-switch v-model="form.remove_comment" active-text="Oui" inactive-text="Non">
                    </el-switch>
                </el-form-item>
            </div>
            <div class="row">
                <el-form-item prop="do_not_do" label="Ne pas faire ?" class="col-lg-9">
                    <el-radio-group size="mini"  v-model="form.do_not_do">
                        <el-radio-button :label="true">Marqué ne pas faire</el-radio-button>
                        <el-radio-button :label="null">Ne pas changer</el-radio-button>
                        <el-radio-button :label="false">Enlevé ne pas faire</el-radio-button>
                    </el-radio-group>
                </el-form-item>
            </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="display = false">Annuler</el-button>
            <el-button type="primary" @click="action">Enregistrer</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
    data() {
        return {
            display: false,
            loader: false,
            form: {
                comment: null,
                remove_comment: false,
                do_not_do: null
            }
        }
    },
    props: {
        applyToAllResult: {
            default: false
        },
        filters: {
            default: null
        },
        selected: {
            default: []
        },
        total_item: {
            default: 0
        }
    },
    computed: {
        items_selected() {
            return this.applyToAllResult
                ? this.total_item
                : this.selected.length;
        },
    },
    methods: {
        open() {
            this.display = true;
            this.$store.dispatch('products/setLoader', false);
        },
        action() {
            var products = this.selected.map(v => v.id);
            this.loader = true;

            var datas = {
                products,
                datas: this.form,
                mode: 'comment'
            };
            if (this.applyToAllResult) {
                datas.filters = this.filters;
            }
            datas.total_item = this.total_item
            datas.items_selected = this.items_selected
            axios
                .post('/products/bulk', datas)
                .then(r => {
                    this.$emit('saved', r);
                    this.$refs.form.resetFields();
                    this.display = false;
                })
                .catch(() => {})
                .then(() => {
                    this.loader = false;
                });
        }
    }
}
</script>
